/* global rp$, window */
'use strict';
var THE_SCRIPT = function () {
	const $onReady = require('public/js/lib/on-ready');

	/********************************************
	 * Load Javascript for the Banner Vpicker Module
	 * -----------------------------------------
	 * @section product_recommended_js
	 ********************************************/

	(function OemAssembliesModule() {
		$onReady({
			rp$, window,
			label: 'oem_assemblies',
			fn: function () {
				// Assembly thumbnails no taller than first assembly image
				if(rp$('#parts_diagram_1').outerHeight() < rp$('.assembly-thumbnails').outerHeight()) {
					rp$('.assembly-thumbnails').css('max-height',rp$('#parts_diagram_1').outerHeight()+'px').css('overflow-y','scroll');
				}

				// Assembly thumbnail click
				rp$('.assembly-thumbnail').on('click',function(e) {
					e.preventDefault();
					var target = this.hash;
					var firstAssembly = rp$('#parts_diagram_0').outerHeight()*.5;
					var $target = rp$(target).offset().top - firstAssembly;
					rp$('html, body').stop().animate({'scrollTop': $target}, 300, 'swing');
				});

				// Hotspot Target click
				rp$('.hotspot-scroll-link').on('click',function(e) {
					e.preventDefault();
					rp$('.product-diagram').modal('hide');
					var closestAssembly = rp$(this).closest('.pp-image-container').outerHeight();
					var target = this.hash;
					var $target = (rp$(target).offset().top - (closestAssembly*.5));
					rp$('html, body').stop().animate({'scrollTop': $target}, 900, 'swing');
				});

				// Hotspot Row Highlight
				rp$('.hotspot, .part-row').on({

					mouseenter: function () {
						var $this = rp$(this);
						var part_group = $this.attr('data-pgr-idx');
						var reference_code = $this.attr('data-reference-code');
						if(part_group && reference_code) {
							if($this.hasClass('hotspot')) {
								rp$('.part-row-'+part_group+'-'+ reference_code).addClass('part-row-highlight');
							}
							rp$(this).addClass('hotspot-highlight-active');
							rp$('.hotspot-'+part_group+'-'+ reference_code).addClass('hotspot-highlight');
						}
						if($this.hasClass('hotspot')) {
							$this.find('.hotspot-menu').show();
						}
					},
					mouseleave: function () {
						var $this = rp$(this);
						var part_group = $this.attr('data-pgr-idx');
						var reference_code = $this.attr('data-reference-code');
						if(part_group && reference_code) {
							if($this.hasClass('hotspot')) {
								rp$('.part-row-'+part_group+'-'+ reference_code).removeClass('part-row-highlight');
							}
							rp$('.hotspot-'+part_group+'-'+ reference_code).removeClass('hotspot-highlight hotspot-highlight-active');
						}
						if($this.hasClass('hotspot')) {
							$this.find('.hotspot-menu').hide();
						}
					}
				});

				rp$('#relatedAssemblies .view-related-assemblies').on('click', function(e) {
					e.preventDefault();
					var $anchor = rp$(this),
						$assemblies = rp$('#relatedAssemblies .related-assemblies-row');

					$anchor.toggleClass('active');
					$assemblies.slideToggle(function () {
						try {
							window.rp_app.frameHandler.forceCheck();
						} catch (e) {
							// Do nothing.. we're just doing an iframe resize... if we're inside one
						}
					});
				});

				// If there was a direct hit on product page, highlight/scrollto that part on-page
				(function() {
					if(rp$('tr.page-part-num').length > 0) {
						window.setTimeout(function() {
							var top_y = rp$('tr.page-part-num').first().offset().top;
							var window_h = rp$(window).height();
							if(window_h < top_y) {
								rp$('body').scrollTop(top_y - (window_h / 3));
							}
						}, 1000);
					}

				})();
			},
		});
	})();
};

try {
	// Because __CURRENT_SCRIPT__ is injected by plugin Client, we need this here to try and pass it up to the plugin code
	__CURRENT_SCRIPT__ = THE_SCRIPT;
} catch (e) {
	THE_SCRIPT();
}
